export const hideWithStars = (str: string, fromPos: number = 0) => str.substr(0, fromPos).padEnd(str.length, '*')